import { render, staticRenderFns } from "./course3.vue?vue&type=template&id=5df45e3d&scoped=true&"
import script from "./course3.vue?vue&type=script&lang=js&"
export * from "./course3.vue?vue&type=script&lang=js&"
import style0 from "./course3.vue?vue&type=style&index=0&id=5df45e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df45e3d",
  null
  
)

export default component.exports